import React, {Component} from 'react';
import './App.css';
import PhotoReel from './components/PhotoReel/PhotoReel';
import Logo from './components/Logo/Logo';
import Amenities from './components/Amenities/Amenities';
import Links from './components/Links/Links';
import Events from './components/Events/Events';
import Hours from './components/Hours/Hours';
import ReviewReel from './components/ReviewReel/ReviewReel';
import Background from './components/Background/Background';
import Summary from './components/Summary/Summary';
import Footer from './components/Footer/Footer';
import Map from './components/Map/Map';

const businessHours = {
  Sunday: '12 PM - 2 AM',
  Monday: '11 AM - 2 AM',
  Tuesday: '11 AM - 2 AM',
  Wednesday: '11 AM - 2 AM',
  Thursday: '11 AM - 2 AM',
  Friday: '11 AM - 2 AM',
  Saturday: '10 AM - 2 AM',
}

const images = [
  // get better version of 1st image
  "https://i.imgur.com/Iit9wgL.jpg",
  "https://i.imgur.com/7VtxL3P.jpg",
  // "https://i.imgur.com/Sfrc8Mh.jpg",
  // remove this image below and maybe get better version
  "https://i.imgur.com/XNkPvC4.jpg",
  "https://i.imgur.com/XWi6b2r.jpg",
  "https://i.imgur.com/HTDWbHa.jpg",
  "https://i.imgur.com/bzZgIwj.jpg",
  "https://i.imgur.com/7QImxgT.jpg",
  // "https://i.imgur.com/xaIdjB5.jpg",
  "https://i.imgur.com/lWXAVUQ.jpg",
  "https://i.imgur.com/FFZmqgD.jpg",
  "https://i.imgur.com/GmBfn31.jpg",
]

const reviewImages = [
  "https://i.imgur.com/RrpneMF.png",
  "https://i.imgur.com/T2ZX3bC.png",
  "https://i.imgur.com/9aEXCru.png",
  "https://i.imgur.com/b8jNU8l.png",
  "https://i.imgur.com/GK1tBLQ.png",
  "https://i.imgur.com/D5mAnG5.png",
  "https://i.imgur.com/w7NE45R.png",
  "https://i.imgur.com/BuL6FCy.png",
  "https://i.imgur.com/w6CWZFN.png",
  "https://i.imgur.com/2wl9NZZ.png",
]

const menuImages = [
  "https://i.imgur.com/ZrvnM8f.jpg",
]
class App extends Component {

  render() {
    return (
      <div className="App">
        <Logo />
        <Links menuImages={menuImages}/>
        <PhotoReel images={images}/>
        <Summary {...Object.values(businessHours)}/>
        <Amenities />
        <Hours {...businessHours}/>
        <ReviewReel reviewImages={reviewImages}/>
        <Map />
        <Events/>
        <Footer />
        <Background />
      </div>
    );
  }
}

export default App;
